import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface OfflineRecordingLeaveDialogProps {
  open: boolean;
  /** Stay here; the recording carries on untouched. */
  onStay: () => void;
  /** Go anyway: the recording is closed off first, and Wundo writes from it. */
  onLeave: () => void;
}

/**
 * The question in front of a link followed while the microphone is open.
 *
 * The microphone lives on this page, so any navigation away from it silently
 * ends the recording — a sidebar link, the way back to the conversations, the
 * back button. Without this the user finds out afterwards, from a verslag that
 * stops halfway.
 *
 * Both answers are honest ones, which is why neither is hidden: somebody who
 * meant to leave gets to leave, and what it costs is said before it costs it.
 */
export function OfflineRecordingLeaveDialog({
  open,
  onStay,
  onLeave,
}: OfflineRecordingLeaveDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onStay()}>
      <DialogContent size='md'>
        <DialogHeader>
          <DialogTitle>{m.meeting_offline_leave_title()}</DialogTitle>
        </DialogHeader>

        <div className='px-5 py-4'>
          <p className='text-sm text-ink-body'>{m.meeting_offline_leave_body()}</p>
        </div>

        <DialogFooter>
          <Button size='sm' variant='quiet' onClick={onLeave}>
            {m.meeting_offline_leave_confirm()}
          </Button>
          <Button size='sm' onClick={onStay}>
            {m.meeting_offline_leave_stay()}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
